"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvelopeIllustration = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var EnvelopeIllustration = function (_a) {
    var _b = _a.color, color = _b === void 0 ? helios_styles_1.brand.primary : _b, _c = _a.size, size = _c === void 0 ? 56 : _c;
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 56 56", fill: "none" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: color, fillRule: "evenodd", d: "M13 18a4 4 0 0 1 4-4h32a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H17a4 4 0 0 1-4-4v-2.417a1 1 0 1 1 2 0V38q.001.27.068.518l11.18-11.181-11.161-9.922A2 2 0 0 0 15 18v2.417a1 1 0 1 1-2 0zm14.745 10.667-.038.04-11.225 11.225Q16.73 40 17 40h32q.27-.001.518-.068L38.293 28.707l-.014-.014-.024-.026-3.927 3.49a2 2 0 0 1-2.657 0zM51 38q-.001.27-.068.518L39.751 27.337l11.162-9.922A2 2 0 0 1 51 18zm-2-22q.227 0 .44.049L33 30.662 16.56 16.05Q16.772 16 17 16z", clipRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { fill: color, d: "M7 24a1 1 0 0 1 1-1h7.559a1 1 0 0 1 0 2h-7.56a1 1 0 0 1-1-1M8 31a1 1 0 1 0 0 2h7.559a1 1 0 0 0 0-2zM3 27a1 1 0 1 0 0 2h12.895a1 1 0 1 0 0-2z" })] })));
};
exports.EnvelopeIllustration = EnvelopeIllustration;
